import React from 'react';
import { TableRow, TableCell, Skeleton, Checkbox } from '@mui/material';
import { TableLoadingSkeletonProps } from '../../types';

export const TableLoadingSkeleton = <
  T extends Record<string, unknown> = Record<string, unknown>,
>({
  columns,
  rowCount = 5,
  dense = false,
  showSelectAll = false,
}: TableLoadingSkeletonProps<T>) => {
  const visibleColumns = columns.filter((col) => !col.hidden);

  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <TableRow key={`loading-row-${rowIndex}`}>
          {showSelectAll && (
            <TableCell padding="checkbox">
              <Checkbox disabled />
            </TableCell>
          )}
          {visibleColumns.map((column, colIndex) => {
            // Handle special columns
            if (column.id === 'select') {
              return (
                <TableCell
                  key={`loading-select-${colIndex}`}
                  padding="checkbox"
                >
                  <Checkbox disabled />
                </TableCell>
              );
            }

            if (column.id === '__expand__') {
              return (
                <TableCell key={`loading-expand-${colIndex}`}>
                  <Skeleton
                    variant="circular"
                    width={24}
                    height={24}
                    animation="wave"
                  />
                </TableCell>
              );
            }

            // Regular content cells
            const cellHeight = dense ? 24 : 32;
            let skeletonWidth = '80%';

            // Vary skeleton widths for more realistic look
            if (colIndex % 3 === 0) skeletonWidth = '60%';
            if (colIndex % 3 === 1) skeletonWidth = '90%';
            if (colIndex % 3 === 2) skeletonWidth = '70%';

            return (
              <TableCell
                key={`loading-cell-${rowIndex}-${colIndex}`}
                align={column.align || 'left'}
                style={{ minWidth: column.minWidth }}
              >
                <Skeleton
                  variant="text"
                  width={skeletonWidth}
                  height={cellHeight}
                  animation="wave"
                  sx={{
                    fontSize: dense ? '0.8rem' : '1rem',
                  }}
                />
              </TableCell>
            );
          })}
        </TableRow>
      ))}
    </>
  );
};
